import { useEffect, useState } from "react";
import { useLocation } from "react-router";

import { useSidePanel } from "../side-panel.hook";

export const useSidePanelCloseListener = () => {
  const location = useLocation();
  const { closeSidePanel } = useSidePanel();

  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    if (isFirstLoad) setIsFirstLoad(false);
    else closeSidePanel();
  }, [location.pathname]);
};
